<template>
    <div id="app">
        <LoadingOverlay v-if="isLoading"/>
        <div v-if="!isLoading">
            <router-view class="view one" name='contact' v-if="currentView === 'contact'"></router-view>
            <router-view class="view two" v-if="currentView === 'beers'"></router-view>
            <router-view class="view three" name="confirm" v-if="currentView === 'confirm'"></router-view>
            <router-view class="view four" name="complete" v-if="currentView === 'complete'"></router-view>
        </div>
    </div>
</template>

<script>
import Translations from "./api/Translations";
import Vue from 'vue';
import LoadingOverlay from "./components/LoadingOverlay";
import Countries from "./api/Countries";
import Categories from "./api/Categories";
import Api from "./api/Api";
import PreviousContent from "./api/PreviousContent";
import PaymentMethods from "./api/PaymentMethods";
import Vat from "./api/Vat";
import _ from 'lodash';

export default {
    name: "App",
    components: {LoadingOverlay},

    store: ['currentView', 'language', 'registration'],

    created() {
        this.language = this.getLanguageFromHost();
        
        // 🐵❗☢️❗☢️❗☢️❗☢️❗ AVOID FORWARD TO MAIN PAGE❗☢️❗☢️❗☢️❗☢️❗ 
        // let urlParams = new URLSearchParams(window.location.search);
        // const avoidCheckStartDateToken = urlParams.get('avoidCheckStartDateToken');
        // console.log("checking start date avoidCheckStartDateToken:", avoidCheckStartDateToken);
        //Prevents loading the app if token is not present, access with http://localhost:8080/ebs-de/?avoidCheckStartDateToken=true#/
        /* use this when in Testing fase in prod and registration is not open yet but date set
        if (avoidCheckStartDateToken == null) {window.location.href = window.location.protocol + "//" + window.location.hostname;} // goto login if providing token avoidCheckStartDateToken
        else {
            this.checkAppAvailiablity(); // Check if registration is available.
            this.load();
            this.getRegistrationFromLocalStorage();
        } */

        // Use this when going live
         this.checkAppAvailiablity();                  // Checks if registration is available.
         this.load();
         this.getRegistrationFromLocalStorage();


    },
    methods: {
        checkAppAvailiablity () {
            Api.get('check/active').then(({data}) => {
                if(!data.active) {
                    window.location.href = window.location.protocol + "//" + window.location.hostname;
                    console.log("Data not active");
                }
            }).catch(() => {
                window.location.href = window.location.hostname;
            });
        },

        getRegistrationFromLocalStorage() {
            if (window.sessionStorage && window.sessionStorage.getItem('registration')) {
                let registration = JSON.parse(window.sessionStorage.getItem('registration'));
                if(this.validateStoredRegistration(registration)){
                    this.registration = registration;
                    this.registration.password = "";
                }
            }
        },

        validateStoredRegistration(registration) {
            let props = [
                'beers',
                'company',
                'contact',
                'hasDeputy',
                'deputy',
                'hasBilling',
                'billing',
                'createUserAccount',
                'vatid',
                'vouchercode',
                'interessent_id',
            ];
           return _.every(props, (prop) => {
               return _.has(registration, prop);
           })
        },

        load() {
            let promises = [
                Translations.load(this.$store.language).then((data) => {
                    Vue.set(this.$store, 'translations', data);
                }),
                Countries.load(this.$store.language).then(({data}) => {
                    Vue.set(this.$store, 'countries', data);
                }),
                Categories.load().then(({data}) => {
                    Vue.set(this.$store, 'categories', data);
                }),
                PreviousContent.load().then(({data}) => {
                   Vue.set(this.$store, 'previousContent', data);
                }),
                PaymentMethods.load().then(({data}) => {
                    Vue.set(this.$store, 'paymentMethods', data);
                }),
                Vat.countries().then(({data}) => {
                    Vue.set(this.$store, 'vatCountries', data);
                }),
                Vat.zipCodes().then(({data}) => {
                    Vue.set(this.$store, 'vatZipCodes', data);
                }),
            ];

            Promise.all(promises).then(() => {
                this.isLoading = false;
            })
        },

        getLanguageFromHost () {
            if(document.querySelector("html").getAttribute('lang') === 'de') {
                return "de";
            } else {
                return "en";
            }
        }
    },

    data() {
        return {
            isLoading: true
        }
    }

}



</script>

<style lang="scss">
    .right {
        float: right;
    }

    form {
        footer button, footer button.buttonReset {
            color: #6f4024;
            background-color: transparent;

            &:hover {
                background-color: transparent;
                color: #bca46e;
            }
        }

        select.L + .errorMessages, input.L + .errorMessages,
        select.S + .errorMessages, input.S + .errorMessages {
            width: 69%;
        }

        button, button.buttonReset {
            color: #bca46e;
            background-color: transparent;

            &.L {
                width: 69%;
            }
        }
    }
</style>